import React, { useState } from 'react';
import './Program.css';
import Nav from '../Nav'; 
import Navbar from '../Navbar';
import Day1 from './Day1';
import Day2 from './Day2';
import Day3 from './Day3';


const Program = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div> 
      <Nav />
      <Navbar />
      
    <div className="tabspan">
      <div className="tabspan-tabs">
        <button
          className={`tabspan-tab ${activeTab === 0 ? 'active' : ''}`}
          onClick={() => handleTabClick(0)}
        >
          Day 1
        </button>
        <button
          className={`tabspan-tab ${activeTab === 1 ? 'active' : ''}`}
          onClick={() => handleTabClick(1)}
        >
          Day 2
        </button>
        <button
          className={`tabspan-tab ${activeTab === 2 ? 'active' : ''}`}
          onClick={() => handleTabClick(2)}
        >
          Day 3
        </button>

      
      </div>
      <div className="tabspan-content">
        {activeTab === 0 && <Day1 />}
        {activeTab === 1 && <Day2 />}
        {activeTab === 2 && <Day3 />}
      
      </div>
    </div>
    </div>
  );
};

export default Program;
